module.exports = __webpack_public_path__ + "static/media/brasier-freeth-project.438392d5.png";